import React, { useState, useEffect } from "react";
import { Radar } from "react-chartjs-2";
import Title from "./Title";

const ChartData = () => {
	const [chartData, setChartData] = useState({});

	const chart = () => {
		setChartData({
			labels: [
				"CSS and Animations",
				"HTML",
				"JavaScript",
				"Node.js",
				"Typescript",
				"REST",
				"React",
				"Stencil.js",
				"Web Components",
				"GraphQL",
			],
			datasets: [
				{
					label: "Interests",
					backgroundColor: "rgba(73,174,186,0.2)",
					borderColor: "rgba(73,174,186,1)",
					pointBackgroundColor: "rgba(255,99,132,1)",
					pointBorderColor: "#fff",
					pointHoverBackgroundColor: "#fff",
					pointHoverBorderColor: "rgba(255,99,132,1)",
					data: [85, 70, 90, 65, 90, 60, 85, 65, 85, 70],
				},
			],
		});
	};

	const options = {
		legend: {
			display: false,
		},
		scale: {
			ticks: {
				beginAtZero: true,
				display: false,
			},
		},
		maintainAspectRatio: false,
	};

	useEffect(() => {
		chart();
	}, []);

	return (
		<div>
			<Title title="Interested in" />
			<div className="canvas-container">
				<Radar data={chartData} options={options} />
			</div>
		</div>
	);
};

export default ChartData;
